import { render, staticRenderFns } from "./TipoGarantiaContratoList.vue?vue&type=template&id=3cd89c27"
import script from "./TipoGarantiaContratoList.vue?vue&type=script&lang=js"
export * from "./TipoGarantiaContratoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports